import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccountService } from '../_services/account.service';


@Injectable()

export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private accountService: AccountService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // 401 - unauthorised (not logged in)
            // 403 - forbidden
            if ([401].includes(err.status) && this.accountService.userDetails) {
                this.accountService.logout(this.router.url);
            }

            return throwError(() => {
                return {
                    message: (typeof err.error.message !== 'undefined') ? err.error.message : err.statusText,
                    errors: (typeof err.error.errors !== 'undefined') ? err.error.errors : []
                };
            });
        }))
    }
}